export default __webpack_public_path__ + "static/upper4_2-c0c13001a88d874ceb28defac703e92a.jpg";